module.exports = __webpack_public_path__ + "img/preview-left.5b9df204.png";